import React from 'react'
import logUtil from 'utils/log'
import Flex from 'components/Flex'
import Image from 'components/Image'
import H3 from 'components/H3'
import './index.css'
import Section from 'components/Section'
import useSelector from 'hooks/use-selector'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import getCurrentMemberShortNameSquadSelect from 'modules/squad/redux/selectors/get-current-member-short-name'

const IMAGE_PATH = 'https://cdn.shopify.com/s/files/1/0569/9957/5718/files/Frame_15156_1.png?v=1696006229'
const ANALYTICS_EVENT = {
  SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET: 'SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET'
}

export default function SquadPageCurrentFriendHasNotTriedSamplesYetContent (props) {
  const currentMemberShortName = useSelector(getCurrentMemberShortNameSquadSelect)
  const debugProps = {
    currentMemberShortName,
    props
  }
  logUtil('SquadPageCurrentFriendHasNotTriedSamplesYetContent').debug('debugProps=', debugProps)

  React.useEffect(() => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_SHOW_CURRENT_FRIEND_HAS_NOT_TRIED_SAMPLES_YET)
  }, [])
  return (
    <Section className='current-friend-has-not-tried-samples-yet'>
      <H3>
        {currentMemberShortName} has not rated <br />any samples yet
      </H3>
      <Flex className='current-friend-has-not-tried-samples-yet-image'>
        <Image src={IMAGE_PATH} />
      </Flex>
    </Section>
  )
}
